import { Avatar, Button, Card, Col, Form, Input, notification, Row, Typography } from 'antd';
import { useSelector } from 'react-redux';
import Meta from 'antd/es/card/Meta';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { logout, updatePassword } from '../../../../store/requests/auth';
import { STATUS } from '../../../../helpers/constants';

const { Text } = Typography;

const MyProfile = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const user = useSelector((state) => state.auth.user);
  const [openUpdatePasswordCard, setOpenUpdatePasswordCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const firstLetter = user.nameSurname ? user.nameSurname.charAt(0).toUpperCase() : '';

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userId: user.id
    };
    setLoading(true);
    updatePassword(payload)
      .then(() => {
        notificationToast(STATUS.SUCCESS, t('updatedPasswordAgainLogin'));
        setOpenUpdatePasswordCard(false);
        logout();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const notificationToast = (type, message) => {
    notification[type]({
      message
    });
  };

  return (<>
    <Row gutter={[24, 24]}>
      <Col span={12}>
        <Card>
          <Meta
            avatar={<Avatar
              style={{
                backgroundColor: '#ffe000', color: '#044180'
              }}
            >
              <Text strong>{firstLetter}</Text>
            </Avatar>}
            title={user.nameSurname}
          />
          <div style={{ marginTop: 20 }}>
            <Text strong>{t('username')}</Text><p>{user.username}</p>
            <Text strong>{t('phoneNumber')}</Text><p>{user.phoneNumber}</p>
            <Text strong>{t('role')}</Text><p>{user.roles[0]?.roleLocalizedValue}</p>
            <Text strong>{t('active')} <Text underline={user.activeStore?.name}>{t('store')}</Text>/<Text
              underline={user.activeRegion?.name}>{t('region')}</Text></Text>
            <p>{user.activeStore?.name ?? user.activeRegion?.name}</p>
            <Button type="link" style={{ paddingInline: 0 }}
                    onClick={() => setOpenUpdatePasswordCard(!openUpdatePasswordCard)}>
              <span style={{ textDecoration: 'underline' }}>{t('clickToUpdatePassword')}</span>
            </Button>
          </div>
        </Card>
      </Col>
      {openUpdatePasswordCard && <Col span={12}>
        <Card>
          <Form
            layout="vertical"
            form={form}
            name="register"
            onFinish={onFinish}
            scrollToFirstError

          >
            <Form.Item
              name="currentPassword"
              label={t('currentPassword')}
              rules={[{
                required: true, message: t('alert.fillField')
              }]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              name="firstPassword"
              label={t('password')}
              rules={[
                {
                  required: true, message: t('alert.fillField')
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value && value.length < 8) {
                      return Promise.reject(t('passwordLength'));
                    }
                    return Promise.resolve();
                  }
                })]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              name="secondPassword"
              label={t('confirmPassword')}
              dependencies={['firstPassword']}
              hasFeedback
              rules={[
                {
                  required: true, message: t('alert.fillField')
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('firstPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('twoPasswordNotEqual')));
                  }
                })
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={() => form.submit()} loading={loading}>
                {t('save')}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>}
    </Row>
  </>);
};

export default MyProfile;
